export const CaretRight = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 6 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path className="stroke-grey-5" d="M5 4L1 8" strokeLinecap="round" />
    <path
      className="stroke-grey-5"
      d="M5 4L1 1.36914e-07"
      strokeLinecap="round"
    />
  </svg>
);
